import ListGroup from "react-bootstrap/ListGroup";
import Placeholder from "react-bootstrap/Placeholder";

function NeedsList({items, isLoading, activeIndex, onSelect}) {

  if(!items.length) return <p>Завантаження...</p>

  return (
    <ListGroup as="ul" variant="flush" onMouseLeave={() => {onSelect(null)}}>
    {
        items.map((item, index) => {
          if(isLoading) {
            return <Placeholder as={ListGroup.Item} animation="glow" key={index}>
              <Placeholder xs={12} />
            </Placeholder>
          }
          
          return <ListGroup.Item
            active={activeIndex === index}
            as="li"
            key={index}
            onMouseEnter={() => {onSelect(index)}}
          >
                <span>{item.name}</span>
                <br />
                <span className="fw-bold">{item.amount.toLocaleString()} ₴</span>
          </ListGroup.Item>
        })
    }
    </ListGroup>
  )
};

export default NeedsList;